import { Outlet, useParams } from "react-router-dom";
import PropertiesPage from "../../../modules/property/PropertiesPage";

const Tab5 = ({ routeBase = "/customer/properties" }) => {
  const { Id } = useParams();

  return Id ? <Outlet /> : <PropertiesPage routeBase={routeBase} />;
};

export default Tab5;
